import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { InputGroup, FormControl, Tooltip } from 'react-bootstrap';
import classNames from 'classnames';
import Button from '../ui/Button';
import SearchTag from './SearchTag';
import {
  SearchParams,
  FreeTextTag,
  DynamicTag,
  AllowedTypeFilters,
  getTypeLabel,
} from '../../utils/searchUtils';
import { retrieveSimpleSearch } from '../../actions/umoGallery';


class SearchSimple extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tagsWidth: 0,
      typeFilter: props.searchParams.get('typeFilter') || '',
      tagList: props.searchParams.get('tagList') || [],
      searchValue: '',
      altsIncluded: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.onSearchInputKeyDown = this.onSearchInputKeyDown.bind(this);
    this.onMeasure = this.onMeasure.bind(this);
    this.removeTag = this.removeTag.bind(this);
    this.editTag = this.editTag.bind(this);
    this.onTypeSelect = this.onTypeSelect.bind(this);
    this.alternatesSearch = this.alternatesSearch.bind(this);
  }

  componentDidUpdate(prevProps) {
    // stop the value from overriding the current value if it's the same
    if (prevProps.searchParams !== this.props.searchParams) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        tagList: this.props.searchParams.get('tagList') ?
          Object.assign([], this.props.searchParams.get('tagList')) : [],
        typeFilter: this.props.searchParams.get('typeFilter') || '',
      });
    }
  }

  onSearchInputChange(e) {
    this.setState({ searchValue: e.target.value });
  }

  onSearchInputKeyDown(e) {
    if (e.keyCode === 8 && this.state.searchValue === '') { // backspace key, not while typing new word
      if (this.state.tagList.length > 0) {
        this.removeTag(this.state.tagList[this.state.tagList.length - 1]);
      }
    }
  }

  // called on render by the Measure component
  // used to measure the length of the tag components so that padding can be added to the
  // search field.
  onMeasure(dimensions) {
    this.setState({ tagsWidth: dimensions.width });
  }

  onSubmit(e) {
    if (e) e.preventDefault();
    if (this.state.searchValue !== '') {
      let tag;
      if (this.state.searchValue.includes(':')) {
        tag = new DynamicTag(this.state.searchValue, this.state.searchValue);
      } else {
        tag = new FreeTextTag(this.state.searchValue, this.state.searchValue);
      }
      this.state.tagList.push(tag);
    }
    if (this.state.tagList.length > 0) {
      this.props.dispatch(
      retrieveSimpleSearch(null, this.state.typeFilter, this.state.tagList, this.state.altsIncluded));
    }
    this.setState({ searchValue: '' });
  }

  onTypeSelect(e) {
    this.setState({ typeFilter: e.target.value });
  }

  removeTag(searchTag) {
    if (this.state.tagList.length > 0) {
      const tagList = this.state.tagList;

      for (let i = 0; i < tagList.length; i += 1) {
        if (tagList[i] === searchTag) {
          tagList.splice(i, 1);
          break;
        }
      }

      this.setState({ tagList }, () => {
        this.onSubmit();
      });
    }
  }

  editTag(searchTag, newValue) {
    if (this.state.tagList.length > 0 && newValue) {
      const tagList = this.state.tagList;

      for (let i = 0; i < tagList.length; i += 1) {
        if (tagList[i] === searchTag && searchTag.value !== newValue) {
          if (searchTag instanceof DynamicTag || newValue.includes(':')) {
            tagList[i] = new DynamicTag(newValue, newValue);
          } else {
            tagList[i] = new FreeTextTag(newValue, newValue);
          }
          this.setState({ tagList }, () => {
            this.onSubmit();
          });
          break;
        }
      }
    }
  }

  alternatesSearch(e) {
    e.preventDefault();
    this.setState({ altsIncluded: !this.state.altsIncluded });
  }

  render() {
    const { intl } = this.props;
    const typeMenuItems = ['', ...AllowedTypeFilters].map(type => (
      <option key={type || ''} value={type}>
        {intl.formatMessage({ id: getTypeLabel(type) })}
      </option>
    ),
    );

    const tags = this.state.tagList ? this.state.tagList.map((searchTag, i) => (
      < SearchTag
        key={i}
        searchTag={searchTag}
        onRemoveClick={this.removeTag}
        onEditClick={this.editTag}
      />
    )) : null;

    return (
      <div className="search-simple">
        <form onSubmit={this.onSubmit} className="form search-simple__form">
          <InputGroup className="search-simple__ip">
            <div className="search-simple__tags">
              {tags}
            </div>
            <FormControl
              className="search-simple__input"
              placeholder={intl.formatMessage({ id: 'searchBar.simple.searchPlaceholder' })}
            // add a bit of padding between the tags and text
              type="text"
              onKeyDown={this.onSearchInputKeyDown}
              value={this.state.searchValue || ''}
              onChange={this.onSearchInputChange}
            />
          </InputGroup>
          <select
            value={this.state.typeFilter}
            className="search-simple__type-input btn btn-default btn-sm"
            onChange={this.onTypeSelect}
            id="simple-input-dropdown-addon"
            title={intl.formatMessage({ id: getTypeLabel(this.state.filter) })}
          >
            {typeMenuItems}
          </select>
          <Button
            variant="primary"
            data-toggle="tooltip"
            title={this.state.altsIncluded ?
              'alternates are included in this search' :
              'Include alternates in search'}
            className={classNames('search-simple__search-button search-simple__alternates', this.state.altsIncluded && 'search-simple__alternates-selected')}
            onClick={this.alternatesSearch}
            delay={{ show: '0' }}
          >
            <span className="umo-grid-item__overlay-alternates-icon">D</span>
          </Button>
          <Button variant="primary" type="submit" className="search-simple__search-button">
            <span className="search-simple__search-icon" />
          </Button>
        </form>
      </div>
    );
  }
}

SearchSimple.propTypes = {
  searchParams: PropTypes.instanceOf(SearchParams),
  dispatch: PropTypes.func,
};

export default injectIntl(SearchSimple);



// WEBPACK FOOTER //
// ./src/js/components/SearchBar/SearchSimple.jsx